// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__37HJd","column":"style_column__3Cpnz","row":"style_row__2khFE"};